import { useEffect } from "react";
import { Crown } from "lucide-react";

const AdSpace = ({ onUpgradeClick, format = "rectangle" }) => {
  useEffect(() => {
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { console.error("AdSense error:", e); }
  }, []);

  return (
    <div className="rounded-2xl shadow-sm p-4" style={{ background: "var(--bg-card)", border: "1px solid var(--border-color)" }} data-testid="ad-space">
      <p className="text-[10px] uppercase tracking-widest mb-3 text-center" style={{ color: "var(--text-muted)" }}>Advertisement</p>
      <div className="flex justify-center">
        <ins className="adsbygoogle" style={{ display: "block" }} data-ad-client="ca-pub-2544310186420203" data-ad-slot="auto" data-ad-format="auto" data-full-width-responsive="true" />
      </div>
      <div className="text-center mt-3">
        <button onClick={onUpgradeClick} className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-[#00bf63] rounded-full hover:bg-[#00a854] transition-colors shadow-sm" data-testid="ad-upgrade-btn">
          <Crown className="w-4 h-4" />Remove Ads
        </button>
      </div>
    </div>
  );
};

export const SidebarAd = ({ size = "medium" }) => {
  useEffect(() => {
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { console.error("AdSense error:", e); }
  }, []);
  const height = size === "large" ? "600px" : "250px";
  return (
    <div className="rounded-2xl shadow-sm p-4" style={{ background: "var(--bg-card)", border: "1px solid var(--border-color)" }}>
      <p className="text-[10px] uppercase tracking-widest mb-3 text-center" style={{ color: "var(--text-muted)" }}>Advertisement</p>
      <div style={{ minHeight: height }}>
        <ins className="adsbygoogle" style={{ display: "block" }} data-ad-client="ca-pub-2544310186420203" data-ad-slot="auto" data-ad-format="vertical" data-full-width-responsive="true" />
      </div>
    </div>
  );
};

export const BannerAd = () => {
  useEffect(() => {
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { console.error("AdSense error:", e); }
  }, []);
  return (
    <div className="rounded-2xl shadow-sm p-4" style={{ background: "var(--bg-card)", border: "1px solid var(--border-color)" }} data-testid="top-ad-banner">
      <p className="text-[10px] uppercase tracking-widest mb-3 text-center" style={{ color: "var(--text-muted)" }}>Advertisement</p>
      <ins className="adsbygoogle" style={{ display: "block" }} data-ad-client="ca-pub-2544310186420203" data-ad-slot="auto" data-ad-format="horizontal" data-full-width-responsive="true" />
    </div>
  );
};

export const InlineAd = ({ onUpgradeClick }) => {
  useEffect(() => {
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { console.error("AdSense error:", e); }
  }, []);
  return (
    <div className="rounded-2xl shadow-sm p-4 my-1" style={{ background: "var(--bg-card)", border: "1px solid var(--border-color)" }} data-testid="inline-ad">
      <p className="text-[10px] uppercase tracking-widest mb-2 text-center" style={{ color: "var(--text-muted)" }}>Sponsored</p>
      <ins className="adsbygoogle" style={{ display: "block" }} data-ad-client="ca-pub-2544310186420203" data-ad-slot="auto" data-ad-format="fluid" data-full-width-responsive="true" />
      {onUpgradeClick && (
        <div className="text-center mt-2">
          <button onClick={onUpgradeClick} className="text-xs font-medium text-[#00bf63] hover:underline" data-testid="inline-ad-remove-btn">
            Remove Ads
          </button>
        </div>
      )}
    </div>
  );
};

export default AdSpace;
